import React, { createContext, useContext, useEffect } from 'react';
import { useFormik } from 'formik';

const defaultValues = {
  onboarding: {
    step: 1,
    is_completed: false,
  },
  copyPrevention: {
    contentCopy: true,
    devTool: true,
    rightClick: true,
  },
  keyboardProtection: {
    enabled: false,
    ctrl_p: false,
    ctrl_s: false,
    ctrl_u: false,
    ctrl_a: false,
    ctrl_x: false,
  },
  warningMessages: {
    textCopy: "Content copying is disabled on this store.",
    devTool: "Developer tools are disabled for security.",
    rightClick: "Right click is disabled on this store.",
    keyboardClick: "Keyboard protection is disabled on this store.",
    ctrl_p: "",
    ctrl_s: "",
    ctrl_u: "",
    ctrl_a: "",
    ctrl_x: "",
  },
  showWarningMessage: {
    textCopy: false,
    devTool: false,
    rightClick: false,
    keyboardClick: false,
    ctrl_p: false,
    ctrl_s: false,
    ctrl_u: false,
    ctrl_a: false,
    ctrl_x: false,
  },
  blockingRules: "",
  geoBlocking: {
    selectedCountry: [],
    showBlockingMessage: false,
    blockingMessage: ""
  },
  blockIp: {
    blockedIpAddresses: [],
    blockingMessage: ""
  },
  blocks: {
    blockedIpAddresses: []
  },
  redirection: {
    enabled: false,
    mode: "monitor",
    allowedDomains: [],
    blockExternalForms: false,
    showWarningMessage: true,
    warningMessage: "This external link is restricted by the store.",
    logRedirects: false
  },
  securityReview: {
    completedSteps: []
  }
};

const FormikContext = createContext(null);

export const FormikProvider = ({ children, initialData }) => {
  const formik = useFormik({
    initialValues: initialData || defaultValues,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log('Form Data (JSON):', JSON.stringify(values, null, 2));
    },
  });

  useEffect(() => {
    if (initialData) {
      formik.resetForm({ values: initialData });
    }
  }, [initialData]);

  return (
    <FormikContext.Provider value={formik}>{children}</FormikContext.Provider>
  );
};

export const useAppFormik = () => {
  const context = useContext(FormikContext);
  if (!context) {
    throw new Error('useAppFormik must be used within FormikProvider');
  }
  return context;
};

export const getFormDataAsJSON = (values) => {
  return JSON.stringify(values, null, 2);
};
